import { Component, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatToolbarModule } from '@angular/material/toolbar';
import { Title } from '@angular/platform-browser';
import { environment } from '@environments/environment';

/**
 * a minimal toolbar with logo and title
 *
 * the title can be set from within component via titleService
 * and be be read on toolbar creation
 */
@Component( {
    selector: 'riege-minimal-toolbar',
    imports: [ MatToolbarModule, MatIconModule, MatButtonModule ],
    templateUrl: './minimal-toolbar.component.html',
    styleUrl: './minimal-toolbar.component.scss'
} )
export class MinimalToolbarComponent {
    #titleService = inject( Title );

    title?: string;

    constructor() {
        this.title = this.#titleService.getTitle() || '';
    }

    checkEnvironmentName( name: string ) {
        return environment.name.startsWith( name );
    }
}
